(() => {
  const root = document.querySelector('[data-co-services-root]');
  if (!root) return;

  const launchDate = new Date(root.dataset.launchDate);
  const launched = Date.now() >= launchDate.getTime();
  const felipe = root.dataset.felipe || '';
  const andrea = root.dataset.andrea || felipe;
  const detail = root.querySelector('[data-service-detail]');
  const booking = root.querySelector('[data-service-booking]');
  const serviceInput = root.querySelector('[data-service-input]');
  const minDateInput = root.querySelector('[data-service-date]');
  const calendar = root.querySelector('[data-service-calendar]');
  const calendarGrid = root.querySelector('[data-calendar-grid]');
  const calendarLabel = root.querySelector('[data-calendar-label]');
  const calendarPrev = root.querySelector('[data-calendar-prev]');
  const calendarNext = root.querySelector('[data-calendar-next]');
  const firstAvailableIso = root.dataset.firstAvailableDate || '2026-10-13';
  const blockedDates = new Set(String(root.dataset.blockedDates || '').split(/[\s,;]+/).map(v => v.trim()).filter(v => /^\d{4}-\d{2}-\d{2}$/.test(v)));
  const sharedWhatsapp = root.dataset.sharedWhatsapp === 'true';
  const firstDateLabel = root.querySelector('[data-service-first-date]');

  const services = {
    diagnostico: {
      name: 'Diagnóstico', kicker: 'DIAGNÓSTICO', icon: 'scan-search',
      title: 'Encontramos primero qué está pasando.',
      points: ['Revisión orientada al síntoma.','Te explicamos qué requiere atención.','Si requiere una pieza, validamos compatibilidad antes.'],
      before: 'La preagenda está abierta. Felipe puede orientarte por WhatsApp antes de confirmar el cupo.',
      advisor: 'Felipe', number: felipe,
      msg: 'Hola Felipe, quiero consultar un problema de mi bicicleta antes de agendar diagnóstico.'
    },
    di2: {
      name: 'Diagnóstico Di2 + informe técnico', kicker: 'DIAGNÓSTICO DI2', icon: 'cpu',
      title: 'Revisamos el sistema y documentamos los hallazgos.',
      points: ['Revisión del sistema Di2 y del síntoma reportado.','Informe técnico con hallazgos y recomendaciones.','Compatibilidad antes de sugerir cambios.'],
      before: 'Si tienes una falla Di2, Felipe puede orientarte y decirte qué información preparar antes de confirmar el diagnóstico.',
      advisor: 'Felipe', number: felipe,
      msg: 'Hola Felipe, tengo una consulta sobre Shimano Di2 y quiero preparar un diagnóstico con informe técnico.'
    },
    instalacion: {
      name: 'Instalación de componente', kicker: 'INSTALACIÓN', icon: 'package-plus',
      title: 'Primero confirmamos que la pieza sí corresponde.',
      points: ['Validación de referencia antes de instalar.','Revisión de compatibilidad con tu bicicleta.','Coordinación según la agenda disponible.'],
      before: 'Andrea puede ayudarte con la preagenda y coordinación; Felipe valida compatibilidad cuando lo necesites.',
      advisor: 'Andrea', number: andrea,
      msg: 'Hola Andrea, quiero consultar una instalación de componente y validar cómo prepararla para el taller.'
    }
  };

  const enc = (v) => encodeURIComponent(v);
  const wa = (number, msg) => `https://wa.me/${String(number).replace(/\D/g,'')}?text=${enc(msg)}`;
  const isSunday = (date) => date.getDay() === 0;

  if (launched) root.classList.add('is-launched');

  const parseLocalDate = (iso) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || '').trim());
    if (!match) return new Date(2026, 9, 13);
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    date.setHours(0,0,0,0);
    return date;
  };
  const toIso = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2,'0');
    const d = String(date.getDate()).padStart(2,'0');
    return `${y}-${m}-${d}`;
  };
  const firstAvailable = parseLocalDate(firstAvailableIso);
  const today = new Date();
  today.setHours(0,0,0,0);
  const effectiveMin = today > firstAvailable ? today : firstAvailable;
  const isBlockedDate = (date) => blockedDates.has(toIso(date));
  const isBookableDate = (date) => date >= effectiveMin && !isSunday(date) && !isBlockedDate(date);
  const nextBookableFrom = (start) => {
    const cursor = new Date(start);
    cursor.setHours(0,0,0,0);
    for (let i = 0; i < 366; i += 1) {
      if (isBookableDate(cursor)) return new Date(cursor);
      cursor.setDate(cursor.getDate() + 1);
    }
    return new Date(start);
  };
  const firstBookable = nextBookableFrom(effectiveMin);
  if (firstDateLabel) {
    firstDateLabel.textContent = new Intl.DateTimeFormat('es-CO', {weekday:'long', day:'numeric', month:'long'}).format(firstBookable);
  }
  if (minDateInput) minDateInput.min = toIso(firstBookable);
  if (minDateInput) {
    minDateInput.addEventListener('change', () => {
      if (!minDateInput.value) {
        minDateInput.setCustomValidity('');
        return;
      }
      const chosen = parseLocalDate(minDateInput.value);
      if (isSunday(chosen)) {
        minDateInput.setCustomValidity('El taller no atiende los domingos. Elige de lunes a sábado.');
        minDateInput.reportValidity();
        minDateInput.value = '';
        return;
      }
      if (chosen < effectiveMin) {
        const minLabel = new Intl.DateTimeFormat('es-CO', {day:'numeric', month:'long'}).format(firstBookable);
        minDateInput.setCustomValidity(`Elige una fecha disponible a partir del ${minLabel}.`);
        minDateInput.reportValidity();
        minDateInput.value = '';
        return;
      }
      if (isBlockedDate(chosen)) {
        minDateInput.setCustomValidity('Esa fecha ya está ocupada. Elige otro día disponible.');
        minDateInput.reportValidity();
        minDateInput.value = '';
        return;
      }
      minDateInput.setCustomValidity('');
      selectedDate = minDateInput.value;
      renderCalendar();
    });
  }

  let calendarCursor = new Date(firstBookable.getFullYear(), firstBookable.getMonth(), 1);
  let selectedDate = '';
  const calendarFloor = new Date(firstBookable.getFullYear(), firstBookable.getMonth(), 1);

  const renderCalendar = () => {
    if (!calendar || !calendarGrid || !calendarLabel) return;
    const year = calendarCursor.getFullYear();
    const month = calendarCursor.getMonth();
    const monthName = new Intl.DateTimeFormat('es-CO', {month:'long', year:'numeric'}).format(calendarCursor);
    calendarLabel.textContent = monthName.charAt(0).toUpperCase() + monthName.slice(1);
    calendarGrid.innerHTML = '';

    const firstDay = new Date(year, month, 1);
    const mondayOffset = (firstDay.getDay() + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    for (let i = 0; i < mondayOffset; i += 1) {
      const empty = document.createElement('span');
      empty.className = 'co-svc__calendar-empty';
      empty.setAttribute('aria-hidden','true');
      calendarGrid.appendChild(empty);
    }

    for (let day = 1; day <= daysInMonth; day += 1) {
      const date = new Date(year, month, day);
      date.setHours(0,0,0,0);
      const iso = toIso(date);
      const available = isBookableDate(date);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'co-svc__calendar-day';
      btn.textContent = String(day);
      btn.dataset.calendarDate = iso;
      btn.setAttribute('role','gridcell');
      btn.setAttribute('aria-label', new Intl.DateTimeFormat('es-CO',{weekday:'long',day:'numeric',month:'long',year:'numeric'}).format(date));
      if (!available) {
        btn.disabled = true;
        const unavailableReason = isSunday(date) ? 'domingo sin atención' : isBlockedDate(date) ? 'fecha ocupada' : 'agendado o no disponible';
        btn.setAttribute('aria-label', `${btn.getAttribute('aria-label')}, ${unavailableReason}`);
      } else {
        btn.setAttribute('aria-label', `${btn.getAttribute('aria-label')}, disponible para solicitar`);
      }
      if (iso === selectedDate) btn.classList.add('is-selected');
      calendarGrid.appendChild(btn);
    }
    if (calendarPrev) calendarPrev.disabled = calendarCursor <= calendarFloor;
    if (window.lucide) window.lucide.createIcons();
  };

  calendarPrev?.addEventListener('click', () => {
    if (calendarCursor <= calendarFloor) return;
    calendarCursor = new Date(calendarCursor.getFullYear(), calendarCursor.getMonth() - 1, 1);
    renderCalendar();
  });
  calendarNext?.addEventListener('click', () => {
    calendarCursor = new Date(calendarCursor.getFullYear(), calendarCursor.getMonth() + 1, 1);
    renderCalendar();
  });
  calendarGrid?.addEventListener('click', (e) => {
    const day = e.target.closest('[data-calendar-date]');
    if (!day || day.disabled) return;
    selectedDate = day.dataset.calendarDate || '';
    if (minDateInput) minDateInput.value = selectedDate;
    renderCalendar();
    if (booking) {
      booking.hidden = false;
      booking.scrollIntoView({behavior:'smooth', block:'start'});
    }
    window.CycloOutletTrack?.('workshop_calendar_date_select', {service: serviceInput?.value || '', date:selectedDate});
  });
  renderCalendar();

  const update = (key) => {
    const s = services[key] || services.diagnostico;
    root.querySelectorAll('[data-service]').forEach(btn => {
      const active = btn.dataset.service === key;
      btn.classList.toggle('is-selected', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const icon = detail.querySelector('.co-svc__detail-icon');
    if (icon) icon.innerHTML = `<i data-lucide="${s.icon}" aria-hidden="true"></i>`;
    detail.querySelector('[data-service-kicker]').textContent = s.kicker;
    detail.querySelector('[data-service-title]').textContent = s.title;
    detail.querySelector('[data-service-copy]').textContent = 'Selecciona un día de lunes a sábado en la preagenda. Confirmamos el cupo contigo por WhatsApp.';
    const points = detail.querySelector('[data-service-points]');
    points.innerHTML = s.points.map(p => `<span><i data-lucide="check" aria-hidden="true"></i>${p}</span>`).join('');
    const action = detail.querySelector('[data-service-action]');
    if (launched) {
      action.textContent = 'Ver preagenda';
      action.removeAttribute('target');
      action.removeAttribute('rel');
      action.href = '#agenda-servicios';
    } else {
      action.textContent = `Consultar con ${s.advisor}`;
      action.target = '_blank';
      action.rel = 'noopener';
      action.href = wa(s.number, s.msg);
    }
    if (serviceInput) serviceInput.value = s.name;
    if (window.lucide) window.lucide.createIcons();
  };

  root.addEventListener('click', (e) => {
    const card = e.target.closest('[data-service]');
    if (card) {
      update(card.dataset.service);
      if (window.innerWidth < 768) detail.scrollIntoView({behavior:'smooth', block:'nearest'});
    }
    const action = e.target.closest('[data-service-action]');
    if (action && launched) {
      e.preventDefault();
      calendar?.scrollIntoView({behavior:'smooth', block:'start'});
      window.CycloOutletTrack?.('workshop_calendar_open', {service: serviceInput?.value || ''});
    }
    if (e.target.closest('[data-service-booking-close]')) booking.hidden = true;
  });

  root.querySelector('[data-service-form]')?.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!launched) return;
    const form = new FormData(e.currentTarget);
    const requestedDate = String(form.get('date') || '');
    if (!requestedDate) {
      minDateInput?.setCustomValidity('Selecciona una fecha para solicitar el servicio.');
      minDateInput?.reportValidity();
      return;
    }
    const requestedLocalDate = parseLocalDate(requestedDate);
    if (!isBookableDate(requestedLocalDate)) {
      minDateInput?.setCustomValidity(isSunday(requestedLocalDate) ? 'El taller no atiende los domingos. Elige de lunes a sábado.' : isBlockedDate(requestedLocalDate) ? 'Esa fecha ya está ocupada. Elige otro día disponible.' : 'Esa fecha no está disponible.');
      minDateInput?.reportValidity();
      return;
    }
    minDateInput?.setCustomValidity('');
    const service = form.get('service') || '';
    const target = /Di2|Diagnóstico/i.test(service) ? felipe : andrea;
    const msg = [
      'Hola CycloOutlet, quiero solicitar un servicio.',
      '', `Servicio: ${service}`,
      `Nombre: ${form.get('name') || ''}`,
      `WhatsApp: ${form.get('phone') || ''}`,
      `Bicicleta: ${form.get('bike') || 'Por confirmar'}`,
      `Fecha solicitada (preagenda): ${requestedDate}`,
      `Qué sucede: ${form.get('problem') || ''}`
    ].join('\n');
    window.CycloOutletTrack?.('workshop_booking_complete', {service});
    window.CycloOutletTrack?.('workshop_whatsapp_route', {service, shared_whatsapp: sharedWhatsapp});
    window.open(wa(target, msg), '_blank', 'noopener');
  });

  root.querySelectorAll('[data-co-advisor]').forEach(link => {
    link.addEventListener('click', () => window.CycloOutletTrack?.('whatsapp_service_click', {advisor: link.dataset.coAdvisor || ''}));
  });

  update('diagnostico');
})();